"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./alignment"), exports);
tslib_1.__exportStar(require("./layout"), exports);
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/pdf-lib/cjs/api/text/index.js